(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[330],{

/***/ 50881:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...slug]",
      function () {
        return __webpack_require__(516);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62991);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97650);
/* harmony import */ var _helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65443);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66714);
/* harmony import */ var _newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50425);
/* harmony import */ var _newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const iconArrowRight = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M0.5 8.5H15.5" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>\n<path d="M10.5 3.5L15.5 8.5L10.5 13.5" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>\n</svg>';
const NewsletterSignUpSection = (props)=>{
    const [newsLetterSignUp, setNewsletterSignUp] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [isShowMessage, setIsShowMessage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { ref , inView  } = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)({
        triggerOnce: true
    });
    const handleOnSuccess = ()=>{
        (0,_helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .setCookie */ .d8)("NewsletterSignUp", "true");
        setIsShowMessage(true);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const newsletterSignUpCookie = (0,_helpers_cookieUtils__WEBPACK_IMPORTED_MODULE_4__/* .getCookie */ .ej)("NewsletterSignUp");
        if (newsletterSignUpCookie && newsletterSignUpCookie !== "") {
            setNewsletterSignUp(true);
        }
    }, [
        newsLetterSignUp
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!inView) {
            return;
        }
        const MktoForms2 = window.MktoForms2;
        const loadMarketoForm = ()=>{
            const newScriptElement = document.createElement("script");
            newScriptElement.onload = ()=>{
                triggerMarketoForm();
            };
            newScriptElement.setAttribute("src", "https://www.workwithsquare.com/js/forms2/js/forms2.min.js");
            document.body.appendChild(newScriptElement);
        };
        const triggerMarketoForm = ()=>{
            var ref;
            if (!window.MktoForms2) {
                return;
            }
            (ref = window.MktoForms2) === null || ref === void 0 ? void 0 : ref.loadForm("//www.workwithsquare.com", "424-IAB-218", 11157, function(form) {
                form.getFormElem().find("button.mktoButton").html('<div class="button-submit"><div class="button-submit-title">Subscribe Now</div>'.concat(iconArrowRight, "</div>"));
                form.getFormElem().find("input.mktoEmailField").attr("placeholder", "Enter your email here...");
                form.onSuccess(function() {
                    handleOnSuccess();
                    return false;
                });
            });
        };
        if (!MktoForms2) {
            loadMarketoForm();
        } else {
            triggerMarketoForm();
        }
    }, [
        inView
    ]);
    if (newsLetterSignUp) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSection),
            ref: ref,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionInfoBackground),
                    children: " "
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionInfo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionTitle),
                        children: "Get small business advice and insights straight to your inbox."
                    })
                }),
                isShowMessage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionAfterSubmit),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            type: _icons__WEBPACK_IMPORTED_MODULE_2__/* .IconType.Subscribed */ .T.Subscribed
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "Thanks!",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                "You're now subscribed."
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
                    id: "mktoForm_11157",
                    className: (_newsletter_signup_section_module_scss__WEBPACK_IMPORTED_MODULE_5___default().newsletterSignUpSectionForm)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewsletterSignUpSection);


/***/ }),

/***/ 516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(75102);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75407);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(62991);
// EXTERNAL MODULE: ./builder/index.ts + 318 modules
var builder = __webpack_require__(21776);
// EXTERNAL MODULE: ./helpers/BuilderHelper.ts
var BuilderHelper = __webpack_require__(31198);
// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(77868);
// EXTERNAL MODULE: ./models/BusinessHub.ts
var BusinessHub = __webpack_require__(48842);
// EXTERNAL MODULE: ./components/layouts/business-hub-layout.tsx + 8 modules
var business_hub_layout = __webpack_require__(53963);
// EXTERNAL MODULE: ./components/meta-block/MetaBlock.tsx
var MetaBlock = __webpack_require__(22135);
;// CONCATENATED MODULE: ./modules/BusinessHubPage.tsx






const BusinessHubPage = (props)=>{
    var ref, ref1;
    const { page  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    return(// https://www.builder.io/c/docs/ab-data-models#getting-the-correct-variation
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(business_hub_layout/* default */.Z, {
        page: page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaBlock/* default */.Z, {
                title: page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.title,
                description: page === null || page === void 0 ? void 0 : (ref1 = page.data) === null || ref1 === void 0 ? void 0 : ref1.description,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "icon",
                    href: "/ap-favicon.ico"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderContent */.Ku, {
                model: "business-hub",
                content: page,
                children: (variant, loading, content)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
                        locale: locale,
                        model: "business-hub",
                        entry: page === null || page === void 0 ? void 0 : page.id,
                        content: content,
                        data: {
                            ...(0,builder/* getBlockDataMap */.LV)({
                                data: variant
                            }),
                            ...variant || {}
                        }
                    }, page === null || page === void 0 ? void 0 : page.id);
                }
            }, page === null || page === void 0 ? void 0 : page.id)
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(54666);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/breadcrumb/breadcrumb.tsx + 1 modules
var breadcrumb = __webpack_require__(53431);
// EXTERNAL MODULE: ./components/layouts/default-layout.tsx + 2 modules
var default_layout = __webpack_require__(87369);
// EXTERNAL MODULE: ./components/newsletter-signup-section/newsletter-signup-section.tsx
var newsletter_signup_section = __webpack_require__(37048);
// EXTERNAL MODULE: ./contexts/LayoutContext.tsx
var LayoutContext = __webpack_require__(21513);
// EXTERNAL MODULE: ./styles/generic.module.scss
var generic_module = __webpack_require__(64256);
;// CONCATENATED MODULE: ./modules/MainPage.tsx











const BusinessResourceLayout = dynamic_default()(()=>__webpack_require__.e(/* import() */ 972).then(__webpack_require__.bind(__webpack_require__, 23179)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(23179)
            ]
    }
});
const MainPage = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { page  } = props;
    let breadcrumbs = [
        {
            name: "Business",
            link: "/business"
        },
        {
            name: (page === null || page === void 0 ? void 0 : page.name) || "",
            link: ""
        }
    ];
    if (page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.breadcrumbs) {
        var _link;
        breadcrumbs = page.data.breadcrumbs.map((data)=>({
                name: data.name,
                link: (_link = data.link) !== null && _link !== void 0 ? _link : data.url
            }));
    }
    const breadcrumbsType = (page === null || page === void 0 ? void 0 : (ref1 = page.data) === null || ref1 === void 0 ? void 0 : ref1.darkTheme) ? "light" : "dark";
    (0,react.useEffect)(()=>{
        var ref;
        const body = document.body;
        if (!body) {
            return;
        }
        if (page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.darkTheme) {
            body.classList.add("dark");
        } else {
            body.classList.remove("dark");
        }
    }, [
        page === null || page === void 0 ? void 0 : (ref2 = page.data) === null || ref2 === void 0 ? void 0 : ref2.darkTheme
    ]);
    const layout = page === null || page === void 0 ? void 0 : (ref3 = page.data) === null || ref3 === void 0 ? void 0 : ref3.layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(default_layout/* default */.Z, {
        breadcrumbs: breadcrumbs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaBlock/* default */.Z, {
                title: page === null || page === void 0 ? void 0 : (ref4 = page.data) === null || ref4 === void 0 ? void 0 : ref4.title,
                description: page === null || page === void 0 ? void 0 : (ref5 = page.data) === null || ref5 === void 0 ? void 0 : ref5.description,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "icon",
                    href: "/ap-favicon.ico"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: generic_module["page-layout"],
                children: layout === LayoutContext/* BusinessTheme.MARKETING_RESOURCE */.E2.MARKETING_RESOURCE ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessResourceLayout, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
                        model: "page",
                        content: page,
                        data: (0,builder/* getBlockDataMap */.LV)(page)
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !(page === null || page === void 0 ? void 0 : (ref6 = page.data) === null || ref6 === void 0 ? void 0 : ref6.hideDefaultBreadcrumbs) && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                            breadcrumbs: breadcrumbs,
                            type: breadcrumbsType || "dark"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(builder_react_es5/* BuilderComponent */.VD, {
                            model: "page",
                            content: page,
                            data: (0,builder/* getBlockDataMap */.LV)(page)
                        })
                    ]
                })
            }),
            layout === LayoutContext/* BusinessTheme.MARKETING_RESOURCE */.E2.MARKETING_RESOURCE ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_signup_section/* default */.Z, {})
        ]
    });
};

// EXTERNAL MODULE: ./helpers/cookieUtils.ts
var cookieUtils = __webpack_require__(65443);
// EXTERNAL MODULE: ./components/not-found/index.tsx
var not_found = __webpack_require__(11170);
;// CONCATENATED MODULE: ./pages/[...slug].tsx












(0,builder/* registerComponents */.QR)();
var PageModel;
(function(PageModel) {
    PageModel["PAGE"] = "page";
    PageModel["BUSINESS_HUB"] = "business-hub";
})(PageModel || (PageModel = {}));
const DefaultPage = (props)=>{
    const { page , model  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const router = (0,next_router.useRouter)();
    const [previewPage, setPreviewPage] = (0,react.useState)(page);
    const [previewModel, setPreviewModel] = (0,react.useState)(model);
    const _getBuilderPreviewPage = async ()=>{
        const locale = (0,LangHelper/* getLocaleFromRoute */._y)(router.asPath);
        const pageId = router.query["builder.overrides.page"];
        if (pageId) {
            const page = await (0,BuilderHelper/* getPageFromPageID */.CN)(pageId);
            if (page) {
                await (0,builder/* awaitBuilderData */.z$)(page, locale);
                setPreviewPage(page);
                setPreviewModel(PageModel.PAGE);
            }
        }
        const businessHubId = router.query["builder.overrides.business-hub"];
        if (businessHubId) {
            const testVariant = router.query["builder.tests.".concat(businessHubId)];
            if (testVariant) {
                (0,cookieUtils/* setCookie */.d8)("builder.tests.".concat(businessHubId), "".concat(testVariant));
            }
            const businessHubPage = await BusinessHub/* default.findById */.Z.findById(businessHubId);
            if (businessHubPage) {
                await (0,builder/* awaitBuilderData */.z$)(businessHubPage, locale);
                setPreviewPage(businessHubPage);
                setPreviewModel(PageModel.BUSINESS_HUB);
            }
        }
    };
    (0,react.useEffect)(()=>{
        // let cancelled = false;
        if (!(builder_react_es5/* Builder.isEditing */.Ib.isEditing || builder_react_es5/* Builder.isPreviewing */.Ib.isPreviewing)) return;
        if (page) return;
        if (router.isFallback) return;
        _getBuilderPreviewPage();
    // return () => {
    //     cancelled = false;
    // };
    }, [
        page,
        router
    ]);
    (0,react.useEffect)(()=>{
        setPreviewPage(page);
    }, [
        page
    ]);
    (0,react.useEffect)(()=>{
        setPreviewModel(model);
    }, [
        model
    ]);
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
            children: "Loading..."
        });
    }
    if (previewPage === null) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(not_found/* NotFound */.T, {
            locale: locale
        });
    }
    if (previewModel === PageModel.BUSINESS_HUB) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessHubPage, {
            page: previewPage
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainPage, {
        page: previewPage
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (DefaultPage);


/***/ }),

/***/ 50425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsletterSignUpSection":"newsletter-signup-section_newsletterSignUpSection__HDAV0","newsletterSignUpSectionInfo":"newsletter-signup-section_newsletterSignUpSectionInfo__QmDXv","newsletterSignUpSectionTitle":"newsletter-signup-section_newsletterSignUpSectionTitle__z_Vcu","newsletterSignUpSectionDescription":"newsletter-signup-section_newsletterSignUpSectionDescription__xkN5J","newsletterSignUpSectionForm":"newsletter-signup-section_newsletterSignUpSectionForm__TmS4Y","newsletterSignUpSectionFormInput":"newsletter-signup-section_newsletterSignUpSectionFormInput__xkKkF","newsletterSignUpSectionAfterSubmit":"newsletter-signup-section_newsletterSignUpSectionAfterSubmit__9Eqeo","fade-in":"newsletter-signup-section_fade-in__f9__6","newsletterSignUpSectionFormBtnSubmit":"newsletter-signup-section_newsletterSignUpSectionFormBtnSubmit__xyl1K","newsletterSignUpSectionInfoBackground":"newsletter-signup-section_newsletterSignUpSectionInfoBackground__5_ixx","video-spin":"newsletter-signup-section_video-spin__1wgzd"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [565,886,564,506,369,170,774,888,179], function() { return __webpack_exec__(50881); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);